<template>
  <v-container>
    <v-sheet>
      <v-row>
        <v-col cols="12" md="2">
          <v-btn
            
            @click="
              (showInformMessageModalForm = true),
                (informMessageFormIsEditing = false)
            "
            >ایجاد اطلاع رسانی جدید</v-btn
          >
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-model="search"
            class="mr-0"
            label="جستجو کنید"
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn class="mr-0" @click="fetchInformMessageItems()">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" md="4">
          <span v-if="!informGroupId" style="color: blue; margin-right: 20px"
            >توجه : ابتدا باید گروه پیام رسانی مورد نظر را انتخاب کنید</span
          >
        </v-col>
      </v-row>
    </v-sheet>
    <v-data-table
      :loading="loadingInformMessageTable"
      :items="informMessageItems"
      :headers="InformMessagesHeader"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:[`item.body`]="{ item }">
        <span> {{ item.body.substring(0, 60) + " ... " }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item
              v-if="
                item.informMessageDeliveryBySMSShortDtos &&
                item.informMessageDeliveryBySMSShortDtos.length > 0 &&
                (item.informMessageDeliveryBySMSShortDtos[0]
                  .informMessageSendStatus == 'Sent' || item.informMessageDeliveryBySMSShortDtos[0]
                  .informMessageSendStatus ==  'Ready')
              "
              link
              color="primary"
              @click="
                getInformMessageSmsResultByResultId(
                  item.informMessageDeliveryBySMSShortDtos[0].id
                )
              "
            >
              <v-list-item-icon>
                <v-icon color="primary" small>mdi-eye</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>نمایش ارسالها</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" @click="showInformMessage(item)">
              <v-list-item-icon>
                <v-icon color="primary" small>mdi-eye</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>نمایش پیام</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <template
              v-if="
            item.informMessageDeliveryBySMSShortDtos &&
            item.informMessageDeliveryBySMSShortDtos.length > 0 &&
           !( item.informMessageDeliveryBySMSShortDtos[0].informMessageSendStatus == 'Ready' ||
            item.informMessageDeliveryBySMSShortDtos[0].informMessageSendStatus == 'Sent')
          "
            >
              <v-list-item
                link
                color="primary"
                @click="editAnnouncements(item)"
              >
                <v-list-item-icon>
                  <v-icon color="primary" small>mdi-lead-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>ویرایش </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-if="item.informMessageDeliveryBySMSShortDtos == null">
              <v-list-item link color="primary" @click="makeReady(item)">
                <v-list-item-icon>
                  <v-icon color="primary" small>mdi-lead-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>آماده سازی جهت ارسال</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template
              v-if="
                item.informMessageDeliveryBySMSShortDtos &&
                item.informMessageDeliveryBySMSShortDtos.length &&
                item.informMessageDeliveryBySMSShortDtos[0]
                  .informMessageSendStatus == 'Ready'
              "
            >
              <v-list-item
                link
                color="primary"
                @click="sendSms(item.informMessageDeliveryBySMSShortDtos[0].id)"
              >
                <v-list-item-icon>
                  <v-icon color="primary" small>mdi-lead-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>ارسال پیامک‌ها</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
               
            </template>
             <template
              v-if="
                item.informMessageDeliveryBySMSShortDtos &&
                item.informMessageDeliveryBySMSShortDtos.length &&
                item.informMessageDeliveryBySMSShortDtos[0]
                  .informMessageSendStatus == 'Sent'
              "
            >
          <v-list-item
                link
                color="primary"
                @click="sendSms(item.informMessageDeliveryBySMSShortDtos[0].id)"
              >
                <v-list-item-icon>
                  <v-icon color="primary" small>mdi-lead-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> بروز رسانی وضعیت</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
          
          </template>
            <v-list-item link color="red" @click="deleteInformMessage(item.id)">
              <v-list-item-icon>
                <v-icon color="red" small>mdi-close</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>حذف</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:[`item.deliveryMessageSendStatus`]="{ item }">
        <span
          v-if="
            item.informMessageDeliveryBySMSShortDtos &&
            item.informMessageDeliveryBySMSShortDtos.length > 0 &&
            item.informMessageDeliveryBySMSShortDtos[0]
              .informMessageSendStatus == 'Ready'
          "
        >
          <v-icon color="primary" small>fa fa-regular fa-hourglass-half</v-icon>
        </span>
        <span
          v-else-if="
            item.informMessageDeliveryBySMSShortDtos &&
            item.informMessageDeliveryBySMSShortDtos.length > 0 &&
            item.informMessageDeliveryBySMSShortDtos[0]
              .informMessageSendStatus == 'Sent'
          "
        >
          <v-icon color="primary" small>fa fa-solid fa-check</v-icon>
        </span>
        <span v-else>
          <v-icon color="primary" small>fa fa-regular fa-paper-plane</v-icon>
          نیاز به آماده‌سازی
        </span>
        <span
          v-if="
            item.informMessageDeliveryBySMSShortDtos &&
            item.informMessageDeliveryBySMSShortDtos.length > 0
          "
        >
          {{
            item.informMessageDeliveryBySMSShortDtos[0]
              .informMessageSendStatusTitle
          }}</span
        >

        <i class="fa-solid fa-message"></i>
      </template>
      <template v-slot:[`item.toBeSendDate`]="{ item }">
        <span> {{ item.toBeSendDate | moment }}</span>
      </template>

      <template v-slot:[`item.informMessageType`]="{ item }">
        <span> {{ getInformMessageTypeTitle(item.informMessageType) }}</span>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-row>
        <v-col cols="12" sm="2" md="2">
          <v-select
            outlined
            dense
            v-model="itemsPerPage"
            :items="[5, 10, 20]"
            label="تعداد نمایش در صفحه"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="10" md="10">
          <v-pagination
            circle
            v-model="pageNumber"
            :length="pageCount"
            :total-visible="5"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="showInformMessageDetailModal" max-width="800">
      <v-card>
        <v-card-title>
          جزئیات
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="closeInformMessageModal()">
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="selectedInformMessage">
          <v-row>
            <v-col cols="12">
              <label for=""> متن پیام : </label>
              <strong>{{ selectedInformMessage.body }}</strong>
              <v-divider></v-divider>
              <span>تعداد کسب و کارهای مشمول پیامک :</span>
              <strong class="text-bold">{{ merchantsCount }}</strong>
               <v-divider></v-divider>
               <span>تعداد کاربران مشمول پیامک :</span>
              <strong>{{ selectedInformMessage.userIds.length }}</strong>
            </v-col>

            <v-col cols="12">
              <v-virtual-scroll
                :items="selectedInformMessage.usersDto"
                height="300"
                item-height="64"
              >
                <template v-slot:default="{ item }">
                  <v-list-item :key="item.userId">
                    <v-list-item-action>
                      <span fab small depressed color="primary">
                        {{ item.name }} {{ item.family }}
                      </span>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>
                        <strong> {{ item.phone }}</strong>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action
                      v-if="
                        !selectedInformMessage.InformMessageDeliveryBySmsListDto &&
                        !selectedInformMessage.informMessageDeliveryBySmsListDto.length > 0
                      "
                    >
                      <v-btn
                        @click="
                          DeleteReceptorUser(
                            selectedInformMessage.id,
                            item.userId
                          )
                        "
                      >
                        <v-icon small> mdi-delete </v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider></v-divider>
                </template>
              </v-virtual-scroll>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color=" error" small @click="closeInformMessageModal()"
            >بستن</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showInformMessageModalForm"
      fullscreen
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar flat dark color="primary" max-height="80px" height="70px">
          <span style="font-weight: 800" v-if="informMessageFormIsEditing">
            ویرایش پیام</span
          >
          <span style="font-weight: 800" v-else> ایجاد پیام</span>
          <span>در گروه پیامهای : </span>
          <span style="font-weight: 900"> {{ informGrouptitle }}</span>
          <v-spacer></v-spacer>
          <!-- <v-btn icon dark @click="showInformMessageModalForm = false" class="ml-5">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        </v-toolbar>

        <v-card-text>
          <InformMessageForm
            @closeModal="closeModal"
            :informgroupId="informGroupId"
            :isEditing="informMessageFormIsEditing"
            :selectedInformGrroup="selectedInformGrroup"
          >
          </InformMessageForm>
        </v-card-text>

        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showInformMessageDeliveryDetailModal" max-width="600">
      <v-card>
        <v-card-title>
          جزئیات ارسال شده شامل :
          {{ informMessageDeliverResultItems.length }}
          پیام
          <v-spacer></v-spacer>
          <v-btn
            icon
            color="error"
            @click="showInformMessageDeliveryDetailModal = false"
          >
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="informMessageDeliverResultItems.length">
          <v-row>
            <v-virtual-scroll
              :items="informMessageDeliverResultItems"
              height="600"
              item-height="80"
            >
              <template v-slot:default="{ item }">
                <v-list-item :key="item.id">
                  <v-list-item-content>
                    <v-list-item-title>
                      <span>گیرنده:</span>
                      <strong> {{ item.receptorPhone }}</strong>
                 
                      <span>وضعیت پیام:</span>
                      <strong> {{ item.smsStatusTypeTitle }}</strong>
                    </v-list-item-title>
                    <span class="mt-2 mb-2">
                      {{ item.message }}
                    </span>
                  </v-list-item-content>
               
               
                </v-list-item>

                
              </template>
            </v-virtual-scroll>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color=" error" small @click="showInformMessageDeliveryDetailModal=false"
            >بستن</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { RepoFactory } from "@/baseRepository/Factory";
const notificationRepository = () => RepoFactory.get("notification");
const enumsRepository = () => RepoFactory.get("enums");
import InformMessageForm from "../components/InformMessageForm.vue";
import Helper from "@/core/helpers";
import { stringify } from "qs";

export default {
  components: {
    InformMessageForm,
  },
  props: {
    informGroupId: {
      type: String,
      default: '1020',
    },
    informGrouptitle: {
      type: String,
      default: null,
    },
    idChanged: {
      type: Boolean,
      default: false,
    },
    selectedInformGrroup: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      showInformMessageDeliveryDetailModal: false,
      search: "",
      showInformMessageModalForm: false,
      informMessageFormIsEditing: false,
      dialog: false,
      informMessageItems: [],
      pageNumber: 1,
      pageCount: 0,
      itemsPerPage: 10,
      loadingInformMessageTable: false,
      InformMessagesHeader: [
        {
          value: "body",
          text: " پیام",
          sortable: true,
        },
        {
          value: "informMessageType",
          text: "نوع پیام  ",
          sortable: true,
        },
        {
          value: "toBeSendDate",
          text: " تاریخ ارسال آتی",
          sortable: false,
        },
        {
          value: "targetUsersCount",
          text: "تعداد مخاطبان",
          sortable: false,
        },
        {
          value: "deliveryMessageSendStatus",
          text: "وضعیت ارسال  ",
          sortable: false,
        },
        {
          value: "actions",
          text: "عملیات",
        },
      ],
      selectedInformMessage: null,
      showInformMessageDetailModal: false,
      informMessageTypes: [],
      informMessagingTypes: [],
      informMessageDeliverResultItems: [],
      // modulelist: [],
      // locationlist: [],
      // alertlist: [],
      // fadeOutTypelist: [],
    };
  },
  created() {
    this.getEnumsByName();
    this.fetchInformMessageItems();
  },
  computed: {
    notificationBaseUrl() {
      return this.$store.getters.notificationBaseUrl;
    },
    merchantsCount() {
      return this.selectedInformMessage?.merchantsPermittedDto?.merchantPermittedList.length;
    },
     currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
  },
  watch: {
       currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
    pageNumber() {
      this.fetchInformMessageItems();
    },
    itemsPerPage() {
      this.fetchInformMessageItems();
    },

    informGroupId() {
      this.fetchInformMessageItems();
    },
  },
  methods: {
    sendSms(deliveryId) {
      //
      const loader = this.$loading.show();
      notificationRepository()
        .sendInformMessage(deliveryId, this.notificationBaseUrl, {})
        .then((res) => {
          this.fetchInformMessageItems();
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    makeReady(item) {
      const loader = this.$loading.show();
      notificationRepository()
        .makeReadyInformMessage(item.id,this.$store.getters.currentMerchant, this.notificationBaseUrl, {})
        .then((res) => {
          this.fetchInformMessageItems();
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    closeModal() {
      this.showInformMessageModalForm = false;
      this.fetchInformMessageItems();
    },
    async getEnumsByName() {
      const loader = this.$loading.show();
      await enumsRepository()
        .getEnum("InformMessageType", this.notificationBaseUrl)
        .then((res) => {
          this.informMessageTypes = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
     
      this.loading = false;
      loader.hide();
    },
    // getModuleTypeTitle(moduleType) {
    //   const item = this.modulelist.find((el) => el.title === moduleType);
    //   if (item) {
    //     return item.displayName;
    //   }
    //   return "";
    // },
    // getLocationTypeTitle(locationType) {
    //   const item = this.locationlist.find((el) => el.title === locationType);
    //   if (item) {
    //     return item.displayName;
    //   }
    //   return "";
    // },
    getInformMessageTypeTitle(type) {
      const item = this.informMessageTypes.find((el) => el.title === type);
      if (item) {
        return item.displayName;
      }
      return "";
    },
    getFadeOutTypeTitle(fadeOutType) {
      const item = this.fadeOutTypelist.find((el) => el.title === fadeOutType);
      if (item) {
        return item.displayName;
      }
      return "";
    },
    showInformMessage(item) {
      const loader = this.$loading.show();
      notificationRepository()
        .getInformMessageById(item.id, this.notificationBaseUrl)
        .then((res) => {
          this.selectedInformMessage = res.data;
          this.showInformMessageDetailModal = true;
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    closeInformMessageModal() {
      this.selectedInformMessage = null;
      this.showInformMessageDetailModal = false;
    },
    openCreateForm() {
      this.$store.commit("setAnnouncementsStatus", true);
    },
    fetchInformMessageItems() {
      console.log("this.informGroupId", this.informGroupId);
      console.log("  this.currentMerchant:",  this.currentMerchant)
      if (this.informGroupId == null || this.$store.getters.currentMerchant==null) {
        return;
      }
      let app = this;
      let params = {
        PageNumber: this.pageNumber,
        ItemsPerPage: this.itemsPerPage,
        Body: this.search,
      };
      this.informMessageItems = [];
      app.loadingInformMessageTable = true
      const loader = this.$loading.show();
      notificationRepository()
        .getInformMessages(
          app.notificationBaseUrl,
          {},
          params,
          this.informGroupId,
          this.$store.getters.currentMerchant,
        )
        .then((res) => {
          app.informMessageItems = res.data.list;
          app.pageCount = Math.ceil(
            Number(res.data.totalCount) / app.itemsPerPage
          );
          app.loadingInformMessageTable = false;
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
 
    deletePage(item) {
      this.$dialog.warning({
        text: `آیا از حذف  <span class="red--text">${item.title}</span> اطمینان دارید؟`,
        title: "هشدار",
        actions: {
          false: {
            color: "red",
            text: "خیر",
          },
          true: {
            color: "primary",
            text: "بله",
            handle: () => {
              const loader = this.$loading.show();
              announcementsRepository()
                .deleteAnnouncements(item.id, this.baseUrl, {})
                .then((res) => {
                  this.fetchInformMessageItems();
                  this.$dialog.message.success("با موفقیت حذف گردید", {
                    position: "top-left",
                  });
                  loader.hide();
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                  loader.hide();
                });
            },
          },
        },
      });
    },
    changeStatus(item) {
      const loader = this.$loading.show();
      if (!item.disabled) {
        announcementsRepository()
          .disableAnnouncements(item.id, this.baseUrl, {})
          .then((res) => {
            this.$dialog.message.success("با موفقیت غیرفعال شد", {
              position: "top-left",
            });
            loader.hide();
            this.fetchInformMessageItems();
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
            loader.hide();
          });
      } else {
        announcementsRepository()
          .enableAnnouncements(item.id, this.baseUrl, {})
          .then((res) => {
            this.$dialog.message.success("با موفقیت فعال شد", {
              position: "top-left",
            });
            loader.hide();
            this.fetchInformMessageItems();
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
            loader.hide();
          });
      }
    },
    deleteInformMessage(messageId) {
      if (messageId) {
        const loader = this.$loading.show();
        this.loading = true;
        notificationRepository()
          .deleteInformMessageById(messageId, this.notificationBaseUrl)
          .then(() => {
            //Update list by removing deleted item from array
            this.$dialog.message.success("پیام با موفقیت حذف شد. ", {
              position: "top-left",
            });
            this.closeModal();
            let findedIndexForTempList = this.informMessageItems.findIndex(
              (el) => el.Id == messageId
            );

            this.informMessageItems.splice(findedIndexForTempList, 1);
            this.loading = false;
            loader.hide();
          })
          .catch((error) => {
            this.loading = false;
            loader.hide();
            Helper.handleErrors(error, this);
          });
      }
    },
    DeleteReceptorUser(informMessageId, userId) {
      if (informMessageId && userId) {
        const loader = this.$loading.show();
        this.loading = true;
        notificationRepository()
          .deleteInformMessageUsers(
            informMessageId,
            userId,
            this.notificationBaseUrl
          )
          .then(() => {
            let findedIndexForTempList =
              this.selectedInformMessage.usersDto.findIndex(
                (el) => el.userId == userId
              );
            this.selectedInformMessage.usersDto.splice(
              findedIndexForTempList,
              1
            );
            this.loading = false;
            loader.hide();
            this.$dialog.message.success("گیرنده پیام با موفقیت حذف شد. ", {
              position: "top-left",
            });
          })
          .catch((error) => {
            this.loading = false;
            loader.hide();
            Helper.handleErrors(error, this);
          });
      }
    },
    getInformMessageSmsResultByResultId(resultId) {
      console.log("resultId is", resultId);
      this.informMessageDeliverResultItems = [];
      const loader = this.$loading.show();
      notificationRepository()
        .getInformMessageSmsResultByResultId(
          resultId,
          this.notificationBaseUrl,
          {},
          {
            PageNumber: 1,
            ItemsPerPage:2000,
          }
        )
        .then((res) => {
         

          this.informMessageDeliverResultItems = res.data.list;
          this.showInformMessageDeliveryDetailModal = true;
          console.log(this.informMessageDeliverResultItems);
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    //
  },
};
</script>

<style></style>
